export const USERLOGIN = 'LOGIN'
export const walletConnnected = 'walletConnnected'
export const customizationPlayer = 'customizationPlayer'

